
<div class="row">
    <div class="col">
        <h3 class="main-title text-center">Select Preferred Date and Time</h3>
    </div>
</div>

<div class="row">
    <div class="col-sm-12 col-md-8 col-lg-7">
        <div class="card floating shadow-lg">
            <br>
            <kendo-multiviewcalendar #ctlSelectedDate [focusedDate]="focusedDate" [value]="selectedDate"
                [views]="calendarViewCount" (activeViewChange)="onActiveViewChange($event)"
                (cellEnter)="onCellEnter($event)" [(ngModel)]="selectedDate" (cellLeave)="onCellLeave($event)"
                (valueChange)="onChange($event)" (blur)="onBlur()" (focus)="onFocus()">
                <ng-template kendoCalendarMonthCellTemplate let-date>
                    {{date.getDate()}}
                </ng-template>
            </kendo-multiviewcalendar>
            <br>
            <div class="row">
                <div class="col text-center">
                    <table style="width: auto;margin:0 auto;">
                        <tr>
                            <td><i class="fas fa-square"
                                    style="background-color:#cccccc!important;color:#cccccc!important;border:1px solid #ddd"></i>&nbsp;Not
                                Available&nbsp;</td>
                            <td><i class="fas fa-square"
                                    style="background-color:#565555!important;color:#565555!important;border:1px solid #ddd"></i>&nbsp;Available&nbsp;
                            </td>
                            <td><i class="fas fa-square"
                                    style="background-color:#009CDE!important;color:#009CDE!important;border:1px solid #ddd"></i>&nbsp;Selected&nbsp;
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <br>
        </div>
    </div>
    <div class="col-sm-12 col-md-4 col-lg-5">
        <div class="card bg-transparent" style="padding-top: 0px;">
            <div class="card-body">
                <h3 class="card-title maint-title">
                    Available Time
                </h3>
                <div class="row"
                    *ngIf="selectedSlot!=null && selectedSlot.timeGroupings!=null && selectedSlot.timeGroupings.length>0">
                    <div class="col-12">
                        <span class="float-right" style="padding: 15px 0px !important;">
                            <b>{{app.dateService.getNewDate(selectedSlot.appointmentDate)|date:'dd'}} |
                                {{app.dateService.getDay(app.dateService.getNewDate(selectedSlot.appointmentDate))}}</b>
                        </span>
                        <ul class="nav nav-tabs">
                            <li class="nav-item" *ngFor="let hour of selectedSlot.timeGroupings; let i = index">
                                <a class="nav-link"
                                    [ngClass]="{'active' : selectedHourGroup!=null && selectedHourGroup.name===hour.name}"
                                    (click)="onPreferredHourGroupClick(hour)">{{hour.name}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 container-fluid bg-white" *ngIf="selectedHourGroup!=null">
                        <div class="row" style="padding-top: 10px;">
                            <div class="col-4 time-available"
                                *ngFor="let item of selectedHourGroup.availableTimes; let i = index"
                                style="padding-bottom: 10px;">
                                <div class="donate-now text-center">
                                    <input type="radio" id="radio{{i}}" value="{{item.time}}" name="time" />
                                    <label for="radio{{i}}" (click)="onPreferredDateClick(item)">
                                        {{app.dateService.formatTime(app.dateService.getNewDate(item.time))}}
                                        <span *ngIf="app.config.showStaff">
                                            <small *ngFor="let slot of item.slots"><br>{{slot.staffName}}</small>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                    *ngIf="selectedSlot==null || selectedSlot.availableHours==null || selectedSlot.availableHours.length==0">
                    <div class="col time-available">
                        No available time.
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br>
                        
                        <button class="btn btn-blue full-width" (click)="next()" [disabled]="isConfirmButtonIsDisabled">
                            Confirm
                        </button>

                        <!-- <div *ngIf="app!=null && app.customer!=null && !app.customer.isNewCustomer && !app.customer.is2YearLastTransaction">
                            <br>
                            <button class="btn btn-blue full-width" (click)="payAtTheAppoitment()" [disabled]="isConfirmButtonIsDisabled || isPassSeven">
                                Pay at the Appointment
                            </button>
                        </div> -->
                    </div>
                    <div class="col-12 text-center"><br>
                        <a class="" (click)="back()">Back</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- 
<div class="row">
    <div class="col-sm-7">
        <mat-card class="card">
            <mat-card-title>
                Select Preferred Date
            </mat-card-title>
            <mat-card-content class="text-center">
                <kendo-multiviewcalendar #ctlSelectedDate [focusedDate]="focusedDate" [value]="selectedDate"
                    [views]="calendarViewCount" (activeViewChange)="onActiveViewChange($event)"
                    (cellEnter)="onCellEnter($event)" [(ngModel)]="selectedDate" (cellLeave)="onCellLeave($event)"
                    (valueChange)="onChange($event)" (blur)="onBlur()" (focus)="onFocus()">
                    <ng-template kendoCalendarMonthCellTemplate let-date>
                        {{date.getDate()}}
                    </ng-template>
                </kendo-multiviewcalendar>
                <br>
                <br>
                <div class="row">
                    <div class="col text-center">
                        <table style="width: auto;margin:0 auto;">
                            <tr>
                                <td><i class="fas fa-square"
                                        style="background-color:#cccccc!important;color:#cccccc!important;border:1px solid #ddd"></i>&nbsp;Not
                                    Available&nbsp;</td>
                                <td><i class="fas fa-square"
                                        style="background-color:#565555!important;color:#565555!important;border:1px solid #ddd"></i>&nbsp;Available&nbsp;
                                </td>
                                <td><i class="fas fa-square"
                                        style="background-color:#009CDE!important;color:#009CDE!important;border:1px solid #ddd"></i>&nbsp;Selected&nbsp;
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <br>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-5">

        <mat-card class="card">
            <mat-card-title>
                Select Preferred Time
            </mat-card-title>
            <mat-card-content class="text-center">
                <div class="row"
                    *ngIf="selectedSlot!=null && selectedSlot.timeGroupings!=null && selectedSlot.timeGroupings.length>0">
                    <div class="col-12">
                        <span class="float-right d-none" style="padding: 15px 0px !important;">
                            <b>{{app.dateService.getNewDate(selectedSlot.appointmentDate)|date:'dd'}} |
                                {{app.dateService.getDay(app.dateService.getNewDate(selectedSlot.appointmentDate))}}</b>
                        </span>
                        <ul class="nav nav-tabs">
                            <li class="nav-item" *ngFor="let hour of selectedSlot.timeGroupings; let i = index">
                                <a class="nav-link"
                                    [ngClass]="{'active' : selectedHourGroup!=null && selectedHourGroup.name===hour.name}"
                                    (click)="onPreferredHourGroupClick(hour)">{{hour.name}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 container-fluid bg-white" *ngIf="selectedHourGroup!=null">
                        <div class="row" style="padding-top: 10px;">
                            <div class="col-4 time-available"
                                *ngFor="let item of selectedHourGroup.availableTimes; let i = index"
                                style="padding-bottom: 10px;">
                                <div class="donate-now text-center">
                                    <input type="radio" id="radio{{i}}" value="{{item.time}}" name="time" />
                                    <label for="radio{{i}}" (click)="onPreferredDateClick(item)">
                                        {{app.dateService.formatTime(app.dateService.getNewDate(item.time))}}
                                        <span *ngIf="app.configService.config.showStaff">
                                            <small *ngFor="let slot of item.slots"><br>{{slot.staffName}}</small>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row"
                    *ngIf="selectedSlot==null || selectedSlot.availableHours==null || selectedSlot.availableHours.length==0">
                    <div class="col time-available">
                        No available time.
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="text-center">
                <button mat-raised-button color="accent" type="button" (click)="back()">
                    <i class="fas fa-chevron-left"></i>&nbsp;Back
                </button>
                <button mat-raised-button color="primary" type="button" (click)="next()"
                    [disabled]="isConfirmButtonIsDisabled">
                    Confirm
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div> -->
<br>

<br>